export default "__VITE_ASSET__CkMq0ylp__"